var React = require('react');

function VideoControlsPlayInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M6 3L21.5 12.5L6 21.5V3Z"}));
}

VideoControlsPlayInline.defaultProps = {"width":"24","height":"24","fill":"none","viewBox":"0 0 24 24"};

module.exports = VideoControlsPlayInline;

VideoControlsPlayInline.default = VideoControlsPlayInline;
